import IndexContent from "../index_content";
import VueStore from "../../../store/VueStore";
import CognitoController from "../../../common/scripts/cognito_controller";
import router from "@/router";

const makeTypes = (self: IndexContent): string[] => {
  const types = Object.assign([], self.graphTypes);
  types.push("graph");
  return types;
};

const setNewInfo = (
  self: IndexContent,
  graphIDs: number[],
  graphTypes: string[],
) => {
  self.graphIDs = graphIDs;
  self.graphTypes = graphTypes;
};

export function makeIds(self: IndexContent): number[] {
  if (typeof self.graphIDs === "undefined" || self.graphIDs.length <= 0) {
    return [1];
  } else {
    const ids: number[] = Object.assign([], self.graphIDs);
    ids.push(Math.max.apply(null, ids) + 1);
    return ids;
  }
}

export async function confirmAddGraph(self: IndexContent) {
  const types: string[] = makeTypes(self);
  const graphIDs: number[] = makeIds(self);
  const cognitoController = new CognitoController();
  cognitoController.setGraphTypes(types);
  cognitoController.setGraphIDs(graphIDs);

  const result = await cognitoController.update();

  setNewInfo(self, graphIDs, types);
  return result;
}
